import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Injector } from '@angular/core'; import { AuthTokenService } from 'src/app/services/auth-token.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs/operators';
import { LayoutService } from './service/app.layout.service'; import { MenuItem } from 'primeng/api';
import { ConfirmationService } from 'primeng/api'; import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service'; import { App } from '@capacitor/app';
import { Router, ActivatedRoute } from '@angular/router'; import { BadgeService } from 'src/app/services/badge.service';
import { PedidosService } from 'src/app/services/pedidos.service'; import { ChatWebSocketService } from 'src/app/services/chat-web-socket.service';
import { ColorScheme, MenuColorScheme, MenuMode } from './service/app.layout.service';
import { PushService } from 'src/app/services/push.service';
import { Subscription } from 'rxjs'; import { Capacitor } from '@capacitor/core';
import { PushWebSocketService } from 'src/app/services/push-web-socket.service';
import { catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs'; // Não esqueça do 'of' se for usar no catchError!
import { ErrorHandlerService } from 'src/app/services/error-handler.service';

import { BadgeCountService } from 'src/app/services/badge-count.service';
import { ChatApiService } from 'src/app/services/chat-api.service';
import { Sidebar } from 'primeng/sidebar';
@Component({
    selector: 'app-profilemenu',
    templateUrl: './app.profilesidebar.component.html'
})
export class AppProfileSidebarComponent implements OnInit, OnDestroy {
    private badgeSub?: Subscription;

    private pushSub?: Subscription;

    constructor(
        private authService: AuthService,
        private errorHandler: ErrorHandlerService,
        private confirmationService: ConfirmationService,
        private chatWebSocketService: ChatWebSocketService,
        private pushWebSocket: PushWebSocketService,
        private pushService: PushService,
        private authTokenService: AuthTokenService,
        private router: Router,
        private route: ActivatedRoute,
        private badgeService: BadgeService,
        private badgeCountService: BadgeCountService,
        private pedidosService: PedidosService,
        private chatApiService: ChatApiService,
        public layoutService: LayoutService,
        private injector: Injector
    ) {
      console.log('[Capacitor] referenced in AppProfileSidebarComponent');
      }
    darkMode: boolean = false;
    get notificationsVisible(): boolean {
        return this.layoutService.state.profileSidebarVisible;
    }
    set notificationsVisible(val: boolean) {
        if (val && this.layoutService.state.anchored) {
            this.layoutService.state.anchored = false;
        }
        this.layoutService.state.profileSidebarVisible = val;
    }

    get chatVisible(): boolean {
        return this.layoutService.state.chatSidebarVisible;
    }
    set chatVisible(val: boolean) {
        if (val && this.layoutService.state.anchored) {
            this.layoutService.state.anchored = false;
        }
        this.layoutService.state.chatSidebarVisible = val;
    }


    get menuTheme(): MenuColorScheme {
        return this.layoutService.config.menuTheme;
    }

    goToProfile(): void {
        this.notificationsVisible = false;
        this.router.navigate(['/profile']);
    }



    changeColorScheme(colorScheme: ColorScheme): void {
        const themeLink = document.getElementById('theme-link') as HTMLLinkElement;
        if (themeLink) {
            const themeLinkHref = themeLink.getAttribute('href');
            const currentColorScheme = 'theme-' + this.layoutService.config.colorScheme;
            const newColorScheme = 'theme-' + colorScheme;
            const newHref = themeLinkHref!.replace(currentColorScheme, newColorScheme);
            this.replaceThemeLink(newHref, () => {
                this.layoutService.config.colorScheme = colorScheme;
                this.layoutService.onConfigUpdate();
            });
        } else {
            console.error('Theme link element not found!');
        }
    }

    replaceThemeLink(href: string, onComplete: () => void): void {
        const id = 'theme-link';
        const themeLink = document.getElementById(id) as HTMLLinkElement;
        const cloneLinkElement = themeLink.cloneNode(true) as HTMLLinkElement;

        cloneLinkElement.setAttribute('href', href);
        cloneLinkElement.setAttribute('id', id + '-clone');

        themeLink.parentNode!.insertBefore(cloneLinkElement, themeLink.nextSibling);

        cloneLinkElement.onload = () => {
            themeLink.remove();
            cloneLinkElement.setAttribute('id', id);
            onComplete();
        };
    }

    toggleTheme(): void {
        // Determina o novo esquema com base no estado do switch const accessToken = localStorage.getItem('access_token');
        const newScheme = this.darkMode ? 'dark' : 'light';
        localStorage.setItem('viewMode', newScheme);
        this.changeColorScheme(newScheme as ColorScheme);
    }
    user_name: string = "";
    isMobile = false;
    unreadCommentsSub?: Subscription;
    private fragmentSub?: Subscription;
    private directChatSub?: Subscription;
    private closeDirectChatSub?: Subscription;
    private closeCommentsSidebarSub?: Subscription;
    private updateDirectChatDescSub?: Subscription;
    ngOnInit(): void {
        if (window.innerWidth <= 768) {
            this.isMobile = true;
        }

        this.fragmentSub = this.route.fragment.subscribe(fragment => {
            if (fragment === 'comments') {
                this.chatVisible = true;
                history.replaceState(null, '', location.pathname + location.search);
            }
        });

        this.directChatSub = this.layoutService.openDirectChat$.subscribe(({ uuid, description, thumbnail }) => {
            this.abrirChatDireto(uuid, description, thumbnail);
        });

        // Segundo clique no botão de chat do header (com a conversa já aberta)
        // — chama o close() do próprio p-sidebar do Chat (mesmo método que o
        // clique no X dispara internamente: hide() -> onHide.emit() [roda
        // desconectarChat(), já ligado no template] -> visibleChange.emit(false)).
        // Tentei antes replicar isso manualmente (setar chatSidebarVisible/
        // chatVisible direto + chamar desconectarChat() eu mesmo) e não deu o
        // mesmo resultado visual — chamar close() de verdade elimina qualquer
        // diferença de ordem/timing em vez de tentar adivinhar.
        this.closeDirectChatSub = this.layoutService.closeDirectChat$.subscribe(() => {
            // close() chama event.preventDefault() internamente — precisa ser cancelable.
            this.chatSidebarRef?.close(new Event('click', { cancelable: true }));
        });

        // Fechar a sidebar de Comentários fora do slick-detail (showChatSidebar/
        // hideChatSidebar em LayoutService) — mesmo motivo do closeDirectChat$
        // acima: precisa do close() de verdade pra onHide disparar e a
        // animação de push acontecer.
        //
        // Se o Chat (conversa individual) estiver aberto por cima, fecha ELE em
        // vez de Comentários direto — desconectarChat() (onHide do Chat) já
        // fecha Comentários em cascata (ver comentário lá). Fechar só
        // Comentários nesse caso deixava o Chat "órfão" aberto por cima, já que
        // as duas sempre trabalham juntas.
        this.closeCommentsSidebarSub = this.layoutService.closeCommentsSidebar$.subscribe(() => {
            if (this.chatSidebarVisible) {
                this.chatSidebarRef?.close(new Event('click', { cancelable: true }));
            } else {
                this.commentsSidebarRef?.close(new Event('click', { cancelable: true }));
            }
        });

        // Atualiza ao vivo a descrição exibida na sidebar de Chat caso ela já
        // esteja aberta na conversa deste mesmo slick (ex.: usuário edita a
        // descrição em Details e clica em Salvar sem fechar o chat).
        this.updateDirectChatDescSub = this.layoutService.updateDirectChatDescription$.subscribe(({ uuid, description }) => {
            if (this.chatSidebarVisible && this.selectedRoomId === uuid && this.selectedComment) {
                this.selectedComment.live_description = description;
            }
        });
        //this.darkMode = this.layoutService.config.colorScheme === 'dark';
        let user_id = localStorage.getItem('user_id');
        if (user_id === null) {
            console.error('User ID is not available in localStorage');
            // Você pode tratar esse caso como achar melhor
        } else {

            // this.badgeSub = this.chatWebSocketService.getBadgeUpdateObservable()
            //     .subscribe((messageData) => {
            //         this.loadMessages(1, '');
            //     });
            // this.chatWebSocketService.connectAdminSocket(user_id);


            this.unreadCommentsSub = this.badgeCountService.getUnreadCommentsCountObservable()
                .subscribe(count => {
                    this.unreadCommentsCount = count;
                });
            let numericUserId = parseInt(user_id, 10);
            this.pedidosService.getCachedUserDetail(numericUserId).subscribe({
                next: (response: any) => {
                    this.user_name = response.name;
                },
                error: (error: any) => {

                }
            });

            this.loadPushs();
            this.loadMessages();
            // 📌 Escuta novos pushes em tempo real
            if (Capacitor.isNativePlatform()) {
                // Escuta quando o app volta para o foreground
                App.addListener('appStateChange', (state) => {
                    if (state.isActive) {
                        this.loadPushs(1); // força reload da página 1
                    }
                });

                this.pushSub = this.pushService.newPush$.subscribe((notification) => {
                    if (notification) {

                        const novoPush = {
                            id: Number(notification.data?.push_notification_id),
                            title: notification.title || '',
                            body: notification.body || '',
                            created_at: new Date().toISOString(),
                            is_read: false,
                            category: notification.data?.category || null,
                            route: notification.data?.route || null
                        };

                        // Adiciona no topo da lista
                        this.pushs.unshift(novoPush);



                        // Atualiza contador global para refletir no p-badge
                        const userId = Number(localStorage.getItem('user_id') || '0');
                        if (userId) {
                            this.pedidosService.refreshUnreadPushCount(userId);
                        }
                    }
                });
            }
            /// socket para atualizar app web - pushes
            const userId = Number(localStorage.getItem('user_id')) || 0;
            const email = localStorage.getItem('ss_email') || '';
            const isLocalhost = window.location.hostname === 'localhost';

            if (!Capacitor.isNativePlatform() && userId && email && !isLocalhost) {
                this.authTokenService.getSocketJwt(userId, email).then(socketToken => {

                    localStorage.setItem('socket_jwt', socketToken);
                    this.pushWebSocket.connect(userId, socketToken);

                    this.pushWebSocket.listenNewPush().subscribe((pushData: any) => {
                        const novoPush = {
                            id: Number(pushData.id),
                            title: pushData.title || '',
                            body: pushData.body || '',
                            created_at: new Date().toISOString(),
                            is_read: false,
                            category: pushData.category || null,
                            route: pushData.route || null
                        };

                        // Adiciona no topo da lista
                        this.pushs.unshift(novoPush);

                        // Atualiza contador global para refletir no p-badge
                        const userId = Number(localStorage.getItem('user_id') || '0');
                        if (userId) {
                            this.pedidosService.refreshUnreadPushCount(userId);
                        }
                    });

                    this.pushWebSocket.listenNewMessage().subscribe((msgData: any) => {
                        // Só atualiza se a mensagem for realmente relevante para o merchant
                        this.comments.unshift(msgData); // se quiser mostrar na lista
                        this.unreadCommentsCount += 1;  // atualiza a badge
                        this.badgeCountService.setUnreadCommentsCount(this.unreadCommentsCount);
                    });

                }).catch(err => {
                    console.error('Erro ao obter JWT para socket:', err);
                });
            }

            /// socket para atualizar app web - pushes


        }

        const accessToken = localStorage.getItem('viewMode');
        if (accessToken == 'dark') {
            this.darkMode = true;
        }
        if (accessToken !== null) {
            this.changeColorScheme(accessToken as ColorScheme);
        }



    }
    pushs: any[] = [];
    pagination = { page: 1, limit: 10, total: 0, pages: 0 };
    hasMore = false;
    loadingPushs = false;
    loadingMorePushs = false;
    onPushImageError(push: any) {
        // Se a URL estiver quebrada, esconde a imagem
        push.image = null;
    }
    async loadPushs(page = 1): Promise<void> {
        const userId = parseInt(localStorage.getItem('user_id') || '0', 10);
        if (!userId) return;

        if (page === 1) this.loadingPushs = true;
        else this.loadingMorePushs = true;

        this.pedidosService.getPushNotificationsForUser(userId, page).subscribe({
            next: async (res: any) => {
                const novas = res.pushes;

                if (page === 1) {
                    this.pushs = novas;
                } else {
                    const novosUnicos = novas.filter((nova: any) =>
                        !this.pushs.some(existente => existente.id === nova.id)
                    );
                    this.pushs = [...this.pushs, ...novosUnicos];
                }

                this.pagination = res.pagination;
                this.hasMore = this.pagination.page < this.pagination.pages;
                this.loadingPushs = false;
                this.loadingMorePushs = false;

                // 🔁 Agora atualiza a contagem de não lidas de forma confiável
                await this.refreshUnreadPushCountAndBadge(userId);
            },
            error: (err) => {
                this.loadingPushs = false;
                this.loadingMorePushs = false;
                console.error('Erro ao buscar notificações:', err);
            }
        });
    }

    refreshPushs(): void {
        this.loadPushs(1);
    }
    unreadCount: number = 0;

    get unreadCountLabel(): string {
        return this.unreadCount > 9 ? '9+' : this.unreadCount.toString();
    }

    get unreadCommentsCountLabel(): string {
        return this.unreadCommentsCount > 9 ? '9+' : this.unreadCommentsCount.toString();
    }

    async refreshUnreadPushCountAndBadge(userId: number): Promise<void> {
        // Cache-first com ETag (src/app/core/http-cache).
        const unreadResource = this.pedidosService.getUnreadPushCountRevalidated(userId);

        toObservable(unreadResource.data, { injector: this.injector }).pipe(
            filter((res): res is { unread_count: number } => res !== null)
        ).subscribe(async res => {
                this.unreadCount = res.unread_count || 0;
                this.pedidosService.setUnreadPushCount(this.unreadCount);
                if (this.unreadCount === 0) {
                    await this.badgeCountService.clearPushBadge();
                } else {
                    await this.badgeCountService.setUnreadPushCount(this.unreadCount);
                }
        });

        toObservable(unreadResource.error, { injector: this.injector }).pipe(
            filter((error): error is any => error !== null)
        ).subscribe(err => {
                console.error('Erro ao atualizar contador de pushs não lidos:', err);
        });
    }


    ngOnDestroy(): void {
        this.badgeSub?.unsubscribe();
        this.pushSub?.unsubscribe();
        this.fragmentSub?.unsubscribe();
        this.directChatSub?.unsubscribe();
        this.closeDirectChatSub?.unsubscribe();
        this.closeCommentsSidebarSub?.unsubscribe();
        this.updateDirectChatDescSub?.unsubscribe();
    }

    async marcarComoLido(push: any) {
        // ✅ Redireciona se houver rota
        if (push.route) {
            this.router.navigate([push.route]);
        }
        if (push.is_read) return; // já lido
        const userId = parseInt(localStorage.getItem('user_id') || '0', 10);

        if (!userId) return;
        this.pedidosService.markPushAsRead(userId, push.id).subscribe({
            next: async () => {
                push.is_read = true;
                // Atualiza contador e badge com base no backend
                await this.refreshUnreadPushCountAndBadge(userId);

                // ✅ Redireciona se houver rota
                if (push.route) {
                    this.router.navigate([push.route]);
                }
            },
            error: (err) => {
                console.error('Erro ao marcar notificação como lida:', err);
            }
        });
    }
    accordionHeader(push: any): string {
        const preview = push.body
            ? push.body.slice(0, 13) + (push.body.length > 13 ? '...' : '')
            : '';
        return `${push.title} - ${preview}`;
    }
    set menuTheme(_val: MenuColorScheme) {
        this.layoutService.config.menuTheme = _val;
    }


    activeTab: number = 0;
    searchTerm = '';
    comments: any[] = [];
    filteredComments: any[] = [];
    paginationComments = { page: 1, limit: 10, total: 0, pages: 1 };
    hasMoreComments = false;
    unreadCommentsCount = 0;
    userId = parseInt(localStorage.getItem('user_id') || '0', 10);
    isLoadingMoreComments = false;
    loadingComments = false;
    loadMessages(page = 1, search = '', callback?: () => void): void {
        if (page === 1) this.loadingComments = true;
        this.userId = parseInt(localStorage.getItem('user_id') || '0', 10);

        // Cache-first com ETag (src/app/core/http-cache).
        const messagesResource = this.pedidosService.getUserMessagesRevalidated(this.userId, page, 10, search);

        toObservable(messagesResource.data, { injector: this.injector }).pipe(
            filter((res): res is any => res !== null)
        ).subscribe((res: any) => {
                const novas = res.messages.map((msg: any) => ({
                    ...msg,
                    // Força UTC removendo o offset (caso queira neutralizar)
                    created_at: typeof msg.created_at === 'string'
                        ? new Date(new Date(msg.created_at).getTime() - (new Date(msg.created_at).getTimezoneOffset() * 60000))
                        : msg.created_at
                }));
                if (page === 1) {
                    // Página inicial: sobrescreve tudo
                    this.comments = novas.filter((nova: any) => !nova.is_admin);
                } else {
                    // Outras páginas: concatena apenas o que não existe
                    const novosUnicos = novas
                        .filter((nova: any) => !this.comments.some(existente => existente.id === nova.id))
                        .filter((nova: any) => !nova.is_admin);
                    this.comments = [...this.comments, ...novosUnicos];
                }
                this.updateGroups();
                this.filteredComments = this.comments; // Pode ajustar filtro local, se quiser
                this.paginationComments = res.pagination;
                this.hasMoreComments = this.paginationComments.page < this.paginationComments.pages;

                this.unreadCommentsCount = res.total_unread ?? 0;//dd
                this.badgeCountService.setUnreadCommentsCount(this.unreadCommentsCount);
                this.loadingComments = false;
                if (callback) callback();
        });

        toObservable(messagesResource.error, { injector: this.injector }).pipe(
            filter((error): error is any => error !== null)
        ).subscribe(err => {
                this.loadingComments = false;
                console.error('Erro ao buscar mensagens:', err);
        });
    }

    refreshComments(): void {
        this.loadMessages(1, this.searchTerm);
    }

    onSearchChange() {
        this.loadMessages(1, this.searchTerm); // faz nova busca no backend com o termo
    }

    carregarMaisComentarios() {
        if (this.isLoadingMoreComments) return; // evita duplo clique
        this.isLoadingMoreComments = true;
        this.loadMessages(this.paginationComments.page + 1, this.searchTerm, () => {
            this.isLoadingMoreComments = false;
        });
    }

    abrirMensagem(comment: any) {
        console.log('Abrir mensagem:', comment);
        // Implemente modal/dialog se quiser detalhar
    }


    getSourceLabel(source: string) {
        switch (source) {
            case 'yt': return 'YouTube';
            case 'ig': return 'Instagram';
            case 'tt': return 'TikTok';
            case 'up': return 'Upload';
            default: return 'Vídeo';
        }
    }
    getSourceColor(source: string) {
        switch (source) {
            case 'yt': return '#ff0000';      // YouTube vermelho
            case 'ig': return '#e1306c';      // Instagram pink
            case 'tt': return '#111';         // TikTok preto
            case 'up': return '#4d6cfa';      // Upload azul customizado
            default: return '#888';           // Cinza
        }
    }

    getSourceIcon(source: string | null | undefined): string {
        if (!source) {
            return '/assets/icons/default_feed.png';
        }
        switch (source.toLowerCase()) {
            case 'uploads':
            case 'up':
                return '/assets/icons/upload_feed.jpg';
            case 'instagram':
            case 'ig':
                return '/assets/icons/instagram.webp';
            case 'tiktok':
            case 'tt':
                return '/assets/icons/tiktok.webp';
            case 'youtube':
            case 'yt':
                return '/assets/youtube-color.svg';
            default:
                return '/assets/icons/default_feed.png';
        }
    }


    itemsButtons = [
        {
            label: 'Exportar comentários',
            icon: 'pi pi-download',
            disabled: true, // Desabilita!
            command: () => {
                // (no futuro, ação de exportar)
            }
        }
    ];

    getAvatarClass(name: string = ''): string {
        const severities = [
            'avatar-primary', 'avatar-info', 'avatar-success',
            'avatar-warning', 'avatar-danger', 'avatar-contrast', 'avatar-secondary'
        ];
        if (!name) return 'avatar-primary';
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        const idx = Math.abs(hash) % severities.length;
        return severities[idx];
    }



    getAvatarLabel(comment: any): string {
        const name = comment.from_name || comment.user_chat_id || '';
        return name.substring(0, 2).toUpperCase();
    }

    get storeId(): string { return localStorage.getItem('ss_SelectedStoreId') ?? ''; }

    chatSidebarVisible = false;
    selectedRoomId: string = '';
    selectedComment: any = null;
    selectedChatMessages: any;


    @ViewChild('chatSearchInput') chatSearchInput?: ElementRef<HTMLInputElement>;
    // Referência ao p-sidebar do Chat — closeDirectChat$ chama o close() dele
    // diretamente (mesmo método interno que o clique no X usa) em vez de
    // tentar replicar manualmente hide()+onHide+visibleChange, garantindo
    // byte a byte o mesmo comportamento/timing da animação de push.
    @ViewChild('chatSidebarRef') chatSidebarRef?: Sidebar;
    // Idem, mas pro p-sidebar de Comentários — usado por closeCommentsSidebar$.
    @ViewChild('commentsSidebarRef') commentsSidebarRef?: Sidebar;
    isLoadingChatMessages = false;

    // Abre a sidebar de Chat direto pelo uuid do slick, sem passar pela lista
    // de Comentários — usado na rota slick/:uuid (ver [[feature-slick-detail-editor-display]]).
    // is_read:true evita a chamada de markMessageAsRead (não há um "comment.id" aqui).
    abrirChatDireto(uuid: string, description?: string, thumbnail?: string) {
        // Abre também a sidebar de Comentários por baixo, como pedido: agora as
        // duas ficam abertas juntas (Comentários embaixo, Chat da conversa em cima).
        this.chatVisible = true;
        this.abrirChat({ live_uniq_id: uuid, is_read: true, live_description: description, thumbnail });
        // Deixa o botão de chat do header saber que a conversa direta já está
        // aberta, pra alternar (fechar) no próximo clique — ver onChatButtonClick.
        this.layoutService.state.directChatVisible = true;
    }

    abrirChat(comment: any) {
        // 1. Normaliza roomId
        const roomId = String(comment?.live_uniq_id ?? '').trim();
        if (!roomId) {
            console.warn('live_uniq_id ausente no comment', comment);
            return;
        }

        this.selectedRoomId = roomId;
        this.selectedComment = comment;

        // 2. Filtra direto pra thread da mensagem clicada (comportamento original,
        // ver [[feature-profile-sidebar-push]]) — vazio quando não há um
        // comment.id específico (ex.: abertura direta via abrirChatDireto),
        // mostrando o chat completo nesse caso.
        this.searchTermChat = String(comment?.id ?? '').trim();

        // 4. **Mostra instantaneamente as mensagens que já tem**
        this.selectedChatMessages = [];
        //this.selectedChatMessages = onlyUserMsgs;

        // 5. Deixa o chat visível logo, sem esperar o backend
        this.chatSidebarVisible = true;

        // 6. Marcar como lido em paralelo (não precisa await)
        if (!comment.is_read) {
            const userId = Number(localStorage.getItem('user_id') || '0');
            this.pedidosService.markMessageAsRead(userId, comment.id).subscribe({
                next: () => {
                    comment.is_read = 1;
                    this.unreadCommentsCount = Math.max(0, this.unreadCommentsCount - 1);
                    this.badgeCountService.setUnreadCommentsCount(this.unreadCommentsCount);
                },
                error: (err) => {
                    console.error('Erro ao marcar mensagem como lida:', err);
                }
            });
        }
        this.isLoadingChatMessages = true;
        const storeId = localStorage.getItem('ss_SelectedStoreId') ?? '';

        this.chatApiService.getMessages(storeId, roomId).subscribe({
            next: (messages) => {
                const normalized = (messages || [])
                    .filter((m: any) => !(m?.is_deleted === true || m?.is_deleted === 1))
                    .map((m: any) => ({
                        ...m,
                        content: m.content ?? m.text ?? '',
                        from_name: m.from_name ?? m.from ?? '',
                        user_chat_id: m.user_chat_id ?? m.ip ?? '',
                        live_uniq_id: roomId
                    }));
                this.selectedChatMessages = this.dedupeById(normalized);
                this.isLoadingChatMessages = false;
                this.onChatFilterChange?.();
                this.chatSearchInput?.nativeElement?.focus();
            },
            error: (err) => {
                this.isLoadingChatMessages = false;
                this.errorHandler.handle(err, 'Falha ao carregar mensagens do chat.');
            }
        });

    }

    onChatMessageCreated(message: any) {
        // Mantém `selectedChatMessages` em sync quando o admin responde pelo ChatBox,
        // evitando ter que dar refresh para ver a resposta na lista.
        if (!message) return;
        const roomId = String(this.selectedRoomId || '').trim();
        if (!roomId) return;

        const msgRoom = String(message?.live_uniq_id ?? message?.chatId ?? '').trim();
        if (msgRoom && msgRoom !== roomId) return;

        const normalized = {
            ...message,
            content: message.content ?? message.text ?? '',
            from_name: message.from_name ?? message.from ?? '',
            user_chat_id: message.user_chat_id ?? message.ip ?? message.from_id ?? '',
            live_uniq_id: roomId
        };

        const current = Array.isArray(this.selectedChatMessages) ? this.selectedChatMessages : [];
        this.selectedChatMessages = this.dedupeById([...current, normalized]);

        // Atualiza filtros/visual se necessário
        this.onChatFilterChange?.();
    }

    onChatMessageRemoved(ev: { id: any; chatId: string }) {
        if (!ev) return;
        const roomId = String(this.selectedRoomId || '').trim();
        if (!roomId) return;
        if (String(ev.chatId || '').trim() !== roomId) return;

        const id = String(ev.id);
        const current = Array.isArray(this.selectedChatMessages) ? this.selectedChatMessages : [];
        this.selectedChatMessages = current.filter(m => String(m?.id) !== id);
        this.onChatFilterChange?.();
    }




    // util simples
    dedupeById<T extends { id: any }>(arr: T[]): T[] {
        const map = new Map<any, T>();
        for (const item of arr) map.set(item.id, item);
        return Array.from(map.values()).sort((a, b) => {
            const ta = new Date((a as any).created_at || 0).getTime();
            const tb = new Date((b as any).created_at || 0).getTime();
            return ta - tb;
        });
    }


    searchTermChat: string = '';
    selectedStatuses: any[] = []; // valores: 'respondida', 'nao_respondida' ou ambos

    statusOptions = [
        { label: 'Respondida', value: 'respondida' },
        { label: 'Não respondida', value: 'nao_respondida' }
    ];

    onChatFilterChange() {
        // Aqui você pode emitir evento ou apenas passar via Input, conforme acima
    }

    clearChatFilters() {
        this.searchTermChat = '';
        this.selectedStatuses = [];
        this.onChatFilterChange();
    }

    filtersCollapsed = false;

    toggleChatFilters() {
        this.filtersCollapsed = !this.filtersCollapsed;
    }

    // Fecha a sidebar do chat atual, mas não mexe na anterior
    closeChatSidebar(event: Event) {
        event.stopPropagation(); // previne toggle duplo
        this.chatSidebarVisible = false;
        // Volta pra lista de Comentários (que continua aberta) — a conversa
        // direta em si não está mais na tela, então o botão de chat do header
        // deve tratar o próximo clique como "abrir" de novo, não "fechar".
        this.layoutService.state.directChatVisible = false;
    }

    hasActiveChatFilters(): boolean {
        // Filtra caso haja texto OU qualquer filtro no multiselect
        return !!(this.searchTermChat?.trim() || (this.selectedStatuses && this.selectedStatuses.length > 0));
    }

    // Em vez de getter
    groupedBySlicks: any[] = [];
    groupedByUser: any[] = [];

    // Sempre que comments mudar (no loadMessages ou onde atualizar), chame:
    private updateGroups() {
        // Agrupa por Slick
        const slicks: { [id: string]: any } = {};
        for (const c of this.comments) {
            const liveId = c.live_id ?? c.live_uniq_id; // Use live_id ou fallback
            if (!liveId) continue;
            if (!slicks[liveId]) {
                slicks[liveId] = {
                    live_id: liveId,
                    live_description: c.live_description,
                    thumbnail: c.thumbnail,
                    unread: 0,
                    comments: [],
                };
            }
            slicks[liveId].comments.push(c);
            if (!c.is_read) slicks[liveId].unread++;
        }
        this.groupedBySlicks = Object.values(slicks)
            .sort((a, b) => b.comments[0]?.created_at.getTime() - a.comments[0]?.created_at.getTime());

        // Agrupa por usuário
        const users: { [id: string]: any } = {};
        for (const c of this.comments) {
            if (!c.user_chat_id) continue;
            if (!users[c.user_chat_id]) {
                users[c.user_chat_id] = {
                    user_chat_id: c.user_chat_id,
                    from_name: c.from_name,
                    unread: 0,
                    comments: [],
                };
            }
            users[c.user_chat_id].comments.push(c);
            if (!c.is_read) users[c.user_chat_id].unread++;
        }
        this.groupedByUser = Object.values(users)
            .sort((a, b) => b.comments[0]?.created_at.getTime() - a.comments[0]?.created_at.getTime());
    }

    tabsOptions: MenuItem[] = [
        { label: 'Todos', command: () => this.setTab(0) },
        { label: 'Slicks', command: () => this.setTab(1) },
        { label: 'Usuários', command: () => this.setTab(2) },
    ];
    activeTabItem = this.tabsOptions[0]; // Começa na primeira aba
    activeTabIndex = 0;

    setTab(index: number) {
        this.activeTabIndex = index;
    }
    renderChatApp = false;
    desconectarChat() {
        this.renderChatApp = false;
        // Fechar o Chat também fecha a Comentários se estiver aberta —
        // evita ficar com a sidebar de Comentários aberta "sozinha" atrás,
        // já que o Chat só é aberto a partir dela (abrirChat/comment).
        if (this.chatVisible) {
            this.chatVisible = false;
        }
        this.layoutService.state.directChatVisible = false;
        this.releasePushNow();
    }

    // (onHide) dispara no INÍCIO do fechamento da sidebar (clique no X), não
    // no fim da animação de saída — diferente do MutationObserver do
    // sidebar-push.js, que só percebe a sidebar sumir quando o Angular
    // remove o nó do DOM, ao FIM da transição de 0.5s. Chamando closeNow()
    // aqui, a tela volta a ocupar o espaço em paralelo com a sidebar
    // fechando, em vez de esperar ela sumir por completo primeiro.
    releasePushNow(): void {
        (window as any).ssProfilePush?.closeNow?.();
    }
    onChipClick(event: MouseEvent, comment: any) {
        event.stopPropagation();

        // Recupera o domínio/sudomínio igual ao método compartilhar()
        const domainStore = localStorage.getItem('domain_store');
        let subdomain = '';
        if (domainStore) {
            const parts = domainStore.split('.');
            if (parts.length >= 2) {
                subdomain = parts[0];
            }
        }

        // Monta a URL igual ao compartilhar
        const url = `${environment.frontendUrl}/${subdomain}?slick_id=${comment.live_uniq_id}`;

        this.confirmationService.confirm({
            message: 'Você será redirecionado para a página do Slick. Deseja continuar?',
            header: 'Redirecionar?',
            icon: 'pi pi-info-circle',
            accept: () => {
                window.open(url, '_blank');
            },
            reject: () => { }
        });
    }


}
